var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"bg-light text-center mt-2 mb-2"},[_c('blockquote',{staticClass:"card-blockquote"},[_vm._t("body",function(){return [(_vm.values && _vm.values.text)?_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.values.text))]):_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.$t('global.empty_data_text')))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }